import { useState, useEffect } from 'react';
import api from '../services/api';

export const useTrusteesFooter = (startDate, endDate) => {
  const [trustees, setTrustees] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchTrustees = async () => {
      setLoading(true);
      try {
        const params = {};
        if (startDate && endDate) {
          params.startDate = startDate;
          params.endDate = endDate;
        }
        const res = await api.get('/settings/pengurus', { params });
        const data = res.data?.data?.data || res.data?.data || [];
        setTrustees(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error('Error fetching trustees:', error);
        setTrustees([]);
      } finally {
        setLoading(false);
      }
    };
    fetchTrustees();
  }, [startDate, endDate]);

  return { trustees, loading };
};

export const TrusteesFooter = ({ trustees, loading }) => {
  if (loading || !trustees.length) return null;

  const pengurus = trustees.filter(t => t.Kelompok === 'Pengurus');
  const pengawas = trustees.filter(t => t.Kelompok === 'Pengawas');
  const pengurusSub = pengurus.filter(t => t.Jabatan === 'Anggota/Panitia Kredit');
  const pengurusRest = pengurus.filter(t => t.Jabatan !== 'Anggota/Panitia Kredit');

  return (
    <div className="trustees-footer mt-4" style={{ fontSize: '7px' }}>
      <hr style={{ margin: '8px 0', border: 'none', borderTop: '1px solid #999' }} />
      <table style={{ width: '100%', border: 'none' }}>
        <tbody>
          <tr>
            <td style={{ width: '50%', verticalAlign: 'top', border: 'none' }}>
              {pengurus.length > 0 && <div><strong>PENGURUS:</strong></div>}
              {pengurusRest.map((t, i) => (
                <div key={`p-${i}`} style={{ marginLeft: '10px' }}>{t.Jabatan} : {t.NamaLengkap}</div>
              ))}
              {pengurusSub.length > 0 && <div style={{ marginLeft: '10px' }}>Anggota/Panitia Kredit :</div>}
              {pengurusSub.map((t, i) => (
                <div key={`ps-${i}`} style={{ marginLeft: '20px' }}>{i + 1}. {t.NamaLengkap}</div>
              ))}
            </td>
            <td style={{ width: '50%', verticalAlign: 'top', border: 'none' }}>
              {pengawas.length > 0 && <div><strong>PENGAWAS:</strong></div>}
              {pengawas.map((t, i) => (
                <div key={`pw-${i}`} style={{ marginLeft: '10px' }}>{t.Jabatan} : {t.NamaLengkap}</div>
              ))}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export const renderTrusteesHtml = (trustees) => {
  if (!trustees.length) return '';

  const pengurus = trustees.filter(t => t.Kelompok === 'Pengurus');
  const pengawas = trustees.filter(t => t.Kelompok === 'Pengawas');
  const pengurusSub = pengurus.filter(t => t.Jabatan === 'Anggota/Panitia Kredit');
  const pengurusRest = pengurus.filter(t => t.Jabatan !== 'Anggota/Panitia Kredit');

  const renderLeft = () => {
    if (!pengurus.length) return '';
    let h = '<div><strong>PENGURUS:</strong></div>';
    pengurusRest.forEach(t => { h += `<div style="margin-left: 10px;">${t.Jabatan} : ${t.NamaLengkap}</div>`; });
    if (pengurusSub.length) {
      h += '<div style="margin-left: 10px;">Anggota/Panitia Kredit :</div>';
      pengurusSub.forEach((t, i) => { h += `<div style="margin-left: 20px;">${i + 1}. ${t.NamaLengkap}</div>`; });
    }
    return h;
  };

  const renderRight = () => {
    if (!pengawas.length) return '';
    let h = '<div><strong>PENGAWAS:</strong></div>';
    pengawas.forEach(t => { h += `<div style="margin-left: 10px;">${t.Jabatan} : ${t.NamaLengkap}</div>`; });
    return h;
  };

  let html = '<div style="margin-top: 20px; font-size: 7px;">';
  html += '<hr style="margin: 8px 0; border: none; border-top: 1px solid #999;" />';
  html += '<table style="width: 100%; border: none;">';
  html += '<tr>';
  html += `<td style="width: 50%; vertical-align: top; border: none;">${renderLeft()}</td>`;
  html += `<td style="width: 50%; vertical-align: top; border: none;">${renderRight()}</td>`;
  html += '</tr></table></div>';
  return html;
};
